import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import { JiraIssueCreateErrorBoundary } from '@atlassian/jira-issue-create-analytics-common/src/ui/jira-issue-create-error-boundary/index.tsx';
import type { Props } from './ui/modal/index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const ConfigureFieldsModal = lazy(
	() =>
		import(/* webpackChunkName: "async-issue-create-configure-fields" */ './ui/modal/index.tsx'),
	{ ssr: false },
);

const LazyConfigureFieldsModal = (props: Props): React.JSX.Element => (
	<JiraIssueCreateErrorBoundary
		id="async.jira.issue-create.configure-fields"
		packageName="jiraIssueCreateConfigureFields"
	>
		<Placeholder name="create-configure-fields-modal" fallback={<></>}>
			<ConfigureFieldsModal {...props} />
		</Placeholder>
	</JiraIssueCreateErrorBoundary>
);

export default LazyConfigureFieldsModal;
